// frontend/src/router/routes/customerRoutes.tsx
// FIXED: Removed booking routes to prevent conflicts

import { Route } from "react-router-dom";
import ProtectedRoute from "@/components/auth/ProtectedRoute";
import CustomerOverview from "@/pages/CustomerOverview";
import CustomerMessages from "@/pages/CustomerMessages";
import CustomerReviews from "@/pages/CustomerReviews";
import CustomerPayments from "@/pages/CustomerPayments";
import CustomerSettings from "@/pages/CustomerSettings";
import CustomerFavorites from "@/pages/CustomerFavorites";
import UserProfile from "@/pages/UserProfile"; // NEW: Import the profile page

// REMOVED: BookingManagement - now handled in bookingRoutes.tsx

export const customerRoutes = [
  // =====================================
  // 🔷 CUSTOMER ACCOUNT ROUTES (NON-BOOKING)
  // =====================================
  <Route
    key="account-overview"
    path="/account"
    element={
      <ProtectedRoute requiredRoles={["user", "customer"]} layout="customer-account">
        <CustomerOverview />
      </ProtectedRoute>
    }
  />,
  <Route
    key="account-messages"
    path="/account/messages"
    element={
      <ProtectedRoute requiredRoles={["user", "customer"]} layout="customer-account">
        <CustomerMessages />
      </ProtectedRoute>
    }
  />,
  <Route
    key="account-reviews"
    path="/account/reviews"
    element={
      <ProtectedRoute requiredRoles={["user", "customer"]} layout="customer-account">
        <CustomerReviews />
      </ProtectedRoute>
    }
  />,
  <Route
    key="profile-settings"
    path="/account/profile"
    element={
      <ProtectedRoute requiredRoles={["user", "customer"]}>
        <UserProfile />
      </ProtectedRoute>
    }
  />,
  <Route
    key="account-payments"
    path="/account/payments"
    element={
      <ProtectedRoute requiredRoles={["user", "customer"]} layout="customer-account">
        <CustomerPayments />
      </ProtectedRoute>
    }
  />,
  <Route
    key="account-settings"
    path="/account/settings"
    element={
      <ProtectedRoute requiredRoles={["user", "customer"]} layout="customer-account">
        <CustomerSettings />
      </ProtectedRoute>
    }
  />,
  <Route
    key="account-favorites"
    path="/account/favorites"
    element={
      <ProtectedRoute requiredRoles={["user", "customer"]} layout="customer-account">
        <CustomerFavorites />
      </ProtectedRoute>
    }
  />,

  // NOTE: All booking routes (/account/bookings, /account/bookings/pending, etc.)
  // have been moved to bookingRoutes.tsx to avoid route conflicts
];